import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import { TMenuItemProps } from "../../../Types";
import ET3Div from "../../../core/et3-div";
import Et3Text from "../../../core/et3-text";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import Et3CustomizedButton from "../../../core/et3-button/Et3CustomizedButton";

const MenuItem = withLiteObserverAndTheme<TMenuItemProps>((props) => {
  const { title, icon, link, theme, visible } = props;
  const { colors, unitX, unitY } = theme;

  return !visible ? null : (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={280}
      height={60}
      fDirection="column"
      alignItems="center"
      justifyContent="flex-start"
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Link
        to={link}
        id="side-bar-menu-item"
        style={{
          textDecoration: "none"
        }}
      >
        <Et3CustomizedButton
          isEnabled={true}
          withShadow={false}
          width={280}
          height={60}
          fDirection="row"
          alignItems="center"
          justifyContent="flex-start"
          color={colors.all.transparent}
          style={{}}
          onClick={() => {}}
        >
          <ET3Div
            isScrollable={false}
            isExtendable={false}
            withShadow={false}
            width={260}
            height={50}
            fDirection="row"
            alignItems="center"
            justifyContent="space-between"
            color={colors.all.transparent}
            style={{}}
            onClick={() => {}}
          >
            <ET3Div
              isScrollable={false}
              isExtendable={false}
              withShadow={false}
              width={190}
              height={50}
              fDirection="row"
              alignItems="center"
              justifyContent="flex-start"
              color={colors.all.transparent}
              style={{}}
              onClick={() => {}}
            >
              <FontAwesomeIcon
                icon={icon}
                color={colors.all.white}
                style={{
                  width: 18 * unitX,
                  height: 18 * unitY
                }}
              />
              <Et3Margin top={0} bottom={0} left={7} right={7} />
              <Et3Text
                fontFamily={"BOLD"}
                fontSize={18}
                text={title}
                isSpan={false}
                color={colors.all.white}
                style={{}}
              />
            </ET3Div>
          </ET3Div>
        </Et3CustomizedButton>
      </Link>
    </ET3Div>
  );
});
export default MenuItem;
